"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressivePrize = void 0;
var ProgressivePrize = /** @class */ (function () {
    function ProgressivePrize(data) {
        this.id = data.id;
        this.content = data.content;
        this.summary = data.summary;
        this.winType = data.winType;
        this.totalWinners = data.totalWinners;
        this.type = data.type;
        this.value = data.value;
        this.drawId = data.drawId;
        this.ceiling = data.ceiling;
    }
    ProgressivePrize.JsonToEntities = function (data) { return data.map(ProgressivePrize.JsonToEntity); };
    ProgressivePrize.JsonToEntity = function (data) { return new ProgressivePrize(data); };
    return ProgressivePrize;
}());
exports.ProgressivePrize = ProgressivePrize;
//# sourceMappingURL=ProgressivePrize.js.map